import { Fragment } from 'react';
import classNames from 'classnames/bind';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import styles from './SideBar.module.scss';
import { closeSidebar } from '~/redux/reducer/module';
import { logoutAccountSuccess } from '~/redux/reducer/auth';

const cx = classNames.bind(styles);

function SideBar() {
    const { currentUser } = useSelector((state) => state.auth);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleToggleSidebar = () => {
        dispatch(closeSidebar());
        document.body.classList.remove('open');
    };

    const handleLoginFreeFire = () => {
        navigate('/freefire-login');
        dispatch(closeSidebar());
        document.body.classList.remove('open');
    };

    const handleLogoutAccount = async () => {
        dispatch(logoutAccountSuccess());
        navigate('/app');
        window.location.reload();
    };

    return (
        <div className={cx('wrapper')}>
            <div className={cx('overlay')} onClick={handleToggleSidebar}></div>

            <div className={cx('content')}>
                {currentUser && (
                    <div className={cx('profile')}>
                        <div className={cx('avatar')} style={{ backgroundImage: `url(${currentUser.img_url})` }}></div>
                        <div className={cx('nickname')}>{currentUser.nickname || currentUser.username}</div>
                    </div>
                )}

                {currentUser ? (
                    <Fragment>
                        <button className={cx('history')} onClick={handleLogoutAccount}>
                            {currentUser?.app?.login_type === 'account_id' ? ' Thoát chế độ ID người chơi' : 'Đăng xuất'}
                        </button>
                    </Fragment>
                ) : (
                    <Fragment>
                        <button className={cx('login')} onClick={handleLoginFreeFire}>
                            <div className={cx('icon')}></div>
                            <span>Đăng nhập</span>
                        </button>
                    </Fragment>
                )}
            </div>
        </div>
    );
}

export default SideBar;
